import { CREDIT_TERMS_DISCLAIMER } from '@/features/billing';

type FlexFundsConfig = {
  creditType: 'flex_funds';
  minCents: number;
  maxCents: number;
  defaultCents: number;
  disclaimer: string;
  snackbarPrefix: string;
};

export const FLEX_FUNDS: FlexFundsConfig = {
  creditType: 'flex_funds',
  minCents: 1000,
  maxCents: 100_000,
  defaultCents: 1000,
  disclaimer: CREDIT_TERMS_DISCLAIMER,
  snackbarPrefix: 'flex-funds',
};
